import SemesterManagement from '../components/SemesterManagement';
import PageLayout from '../components/pageLayout';

function SemesterManagementPage() {
    return (
        <PageLayout children={<SemesterManagement />} />
    );
}

export default SemesterManagementPage;
